<template lang="pug">
  div.condition
    v-select(
      class="filter__operator"
      :items="operators"
      item-text="name"
      v-model="selectedOperator"
      return-object
    )
    v-text-field(
      class="filter__value"
      v-model="selected.value"
      v-if="selectedOperator"
      type="number"
      step="any"
    )
    v-tooltip(bottom v-if="selectedOperator && value.help")
      template(slot="activator")
        v-icon.help help
      span {{ value.help }}

    v-spacer
</template>

<script>

import { IntegerQueryBuilder } from '@/Core/utilities/filter-query-builders/IntegerQueryBuilder';

export default {
  props: {
    /**
     * Value is the "selected condition" which looks like this:
     *
     * {
     *   field: "total_activities",
     *   operator: "$gt",
     *   type: "integer",
     *   value: "15",
     * }
     */
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedOperator: null,
      selected: {
        operator: null,
        value: null,
      },
      operators: IntegerQueryBuilder.OperatorList,
    };
  },

  methods: {

    /**
     * First try to find the right operator and value from the list, matching:
     *  "is zero" and "is one"
     *
     * Failing that, try to find by operator and whether a value is needed.
     */
    setSelectedOperator() {
      this.selectedOperator = this.operators.find(({ name, value }) => {
        return name === this.value.operator && value === this.value.value;
      });

      if (!this.selectedOperator) {
        this.selectedOperator = this.operators.find(({ name, needValue }) => {
          return name === this.value.operator;
        });
      }
    },
  },

  mounted() {
    this.selected = Object.assign({}, this.value);
    this.setSelectedOperator();
    this.$watch('selectedOperator', selectedOperator => {
      this.$emit('input', {
        operator: selectedOperator.name,
        value: selectedOperator.needValue ? this.selected.value : selectedOperator.value,
      });
    }, { deep: true });

    this.$watch('selected', selected => {
      this.$emit('input', {
        operator: this.selectedOperator.name,
        value: selected.value,
      });
    }, { deep: true });
  },
};
</script>
